import s from '../allservices.jsx';
import { getClientId, getClientSecret,buildClientHeader } from '../../utils/clientAuth.js';

const getProfielService = (actionCallback , history) => {
    const memberId = localStorage.getItem("memberId")
    let token = "Token " + localStorage.getItem('token')
   
    let traceId = getClientId();
    let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
    fetch(plink + s.get_profile + "/" + memberId , {
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': token,
            'X-Trace-Id': traceId,
            'X-Client-APP':buildClientHeader(),
        })
    })
        .then(res => {
            if (res.status === 200 || res.status === 201 || res.status === 204 || res.status === 304) {
                res.json().then(json => actionCallback(json, "success"))
            } else if (res.status === 401) {
               
                // localStorage.clear();
                //  this.props.history.push("/")
                if(history !== undefined){
                    history.push("/sessionout")
                }
                   
                let errorOut= "logout"
                actionCallback(errorOut)
            
               
            }
            else {
                // res.json().then(json => actionCallback(json, "error"))
            }
        })
}

export default getProfielService;


// WEBPACK FOOTER //
// ./src/services/components/get_profile.jsx